import styled from "styled-components";
import cssVars from "../../../../styles/cssVariables.vars";
const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContent = styled.div`
  background-color: ${cssVars.colorGrey["7"]};
  padding: 2rem;
  border-radius: 0.5rem;
  width: 90%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);

  h3 {
    font-size: 1.25rem;
    font-weight: 600;
    color: ${cssVars.colorGrey[1]};
    margin-bottom: 1rem;
  }

  p {
    font-size: 0.95rem;
    color: ${cssVars.colorGrey[3]};
    margin-bottom: 0.5rem;
  }
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;

  button {
    padding: 0.5rem 1.25rem;
    border-radius: 0.375rem;
    border: none;
    cursor: pointer;
    font-weight: 500;
    font-size: 0.95rem;
    transition: filter 0.2s ease-in-out;

    &.confirm {
      background-color: var(--color-primary-o);
      color: white;

      &:hover {
        background-color: var(--color-primary);
      }
    }

    &.cancel {
      background-color: ${cssVars.colorGrey["6h"]};
      color: ${cssVars.colorGrey[1]};

      &:hover {
        filter: brightness(1.1);
      }
    }
  }
`;
export { ModalOverlay, ModalContent, ModalActions };